import * as React          from 'react';
import {cs}                from '@Common/react/chain-services';

import {ReactGAGuestEvent} from '@Common/libs/ga/xd-react-ga';
import {consumeContext}    from '@Common/react/context';
import {scopedState}       from '@Common/react/scoped-state';
import {Load2}             from '@Common/react/load2';
import {scrollIntoView}    from '@Common/ui-components/light/scroll-into-view';
import {loadFb}            from '@Xpresso/loaders/load-facebook-auto-login';

export const FacebookLoginButton = ({content, apiError, domRef}) => cs(
    consumeContext("apis"),
    consumeContext("themeScheme"),
    ["load", ({systemConstants}, next) => (
        Load2({
            _key: JSON.stringify(systemConstants),
            fetch: () => loadFb(systemConstants?.value?.FB_APP_ID),
            next
        })
    )],
    ({apis, load, themeScheme}) => (<>
        <button
            className="facebook-button"
            onClick={() => load.value?.login((response) => {
                document.cookie = "disable_facebook_auto_login=1; path=/"
                if (response.authResponse) {
                    handleLogin({response, content, apis, apiError, domRef, themeScheme})
                } else {
                    console.warn("Login failed or user canceled.");
                    console.warn("Response:", response);
                }
            }, {scope: "public_profile,email", auth_type:"rerequest"})}
            style={{
                width: '400px',
                backgroundColor: '#4267b2',
                color: '#fff',
                fontSize: '16px',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '4px',
            }}
        >
            Continue with Facebook
        </button>
    </>)
)

const handleLogin = async ({response, content, apis, apiError, domRef, themeScheme}) => {
    try {
        scopedState(content, ["loading"]).onChange(true)
        let data = await apis.next.authenticate.facebookLogin({
            token: response.authResponse.accessToken
        })
        data.statusCode === "success" ? (
            ReactGAGuestEvent({
                eventName: "login",
                method: "Facebook",
                reason: data.message,
                statusCode: data.statusCode
            }),
            localStorage.setItem('jsonwebtoken', data.accessToken),
            themeScheme?.enableGuestCheckout
            ? location.reload()
            : location.replace("/app")
        ) : (
            ReactGAGuestEvent({
                eventName: "login_failed",
                method: "Facebook",
                reason: data.message,
                statusCode: data.statusCode
            }),
            apiError.onChange(data),
            data?.data?.idUser && scopedState(content, ["content"]).onChange("signin"),
            scopedState(content, ["loading"]).onChange(false),
            scrollIntoView(domRef.get())
        )
    } catch (error) {
        scopedState(content, ["loading"]).onChange(false);
        console.error(error);
    }
}